import { ListItem, ListItemText } from "common/components";
import { FlowData, FlowStep } from "core/api";
import { useTranslation } from "i18n";
import { Fragment } from "react";

export interface DecisionConfirmationProps {
  step: FlowStep;
  flowData: FlowData;
}

/**
 * Sub component to confirmation. The purpose of this component is
 * to make the main Confirmation component more readable,
 * abstracting some of the logic into smaller sub components.
 *
 * DecisionConfirmation is specific to confirmation steps where
 * the flow contains a step with the uiComponent: "Decision".
 *
 * @param flowData data property from the flow object, this is fetched through
 * const flowData = flow.data[step.id]; in the parent component.
 * @returns A JSX element with the decision that was selected in the "Decision" step in the flow.
 */
export function DecisionConfirmation({
  step,
  flowData,
}: DecisionConfirmationProps): JSX.Element {
  const { t } = useTranslation();
  const { selectedDecision = undefined, decisionChoices = undefined } =
    flowData.uiComponent === "Decision" ? flowData : {};

  // Get the name of the selected decision
  const decision = decisionChoices?.find((vv) => vv.id === selectedDecision);

  return (
    <Fragment key={step.id}>
      <ListItem>
        <ListItemText
          primary={t("common:decision")}
          secondary={decision?.name}
          data-cy={"confirmDecision"}
        />
      </ListItem>
    </Fragment>
  );
}
